export default __webpack_public_path__ + "static/media/icon-arquivos.12b621a3.svg";